import './quotes.scss';

/**
 * version    1.0
 * class      <type> (quotes)
 * classdesc  Component quotes
 */
export class Quotes {}
